// extracted by mini-css-extract-plugin
export var container = "_40-0";
export var containerTopRight = "_40-1";